import React from 'react';

import { Container } from '../Layout/Container';
import { Wrapper } from '../Layout';

import classes from './Footer.scss';
import { FooterCta } from './FooterCta';
import { FooterMenu, FooterMenus } from './FooterMenus';
import { FooterContact } from './FooterContact';
import { FooterLogo } from './FooterLogo';

type Props = {
    jhMenu: FooterMenu[];
};

export const FooterWhite: React.FC<Props> = ({ jhMenu }) => (
    <Wrapper className={classes.footer} element="footer" bg="white">
        <Container variant="mobile-no-padding">
            <div className={classes.footerCta}>
                <FooterLogo theme="white" />
                <FooterCta />
            </div>
            <FooterMenus menus={jhMenu} theme="white" />
            <FooterContact theme="white" />
        </Container>
    </Wrapper>
);
